import React, { useState, useEffect, useCallback, forwardRef } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import PersonNotQueryIcon from '@material-ui/icons/RadioButtonUnchecked';
import PersonReportedIcon from '@material-ui/icons/Cancel';
import PersonNotReportedIcon from '@material-ui/icons/CheckCircle';
import SearchIcon from '@material-ui/icons/Search';
import EmailIcon from '@material-ui/icons/Email';
import SMSIcon from '@material-ui/icons/Sms';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

import { PreLoader } from 'app/components/PreLoader';
import moment from 'moment';

import { Helmet } from 'react-helmet-async';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { useTranslation } from 'react-i18next';
import { messages } from './messages';

import { makeStyles } from '@material-ui/core/styles';

import NotificationAdminContext from 'contexts/notification/admin/Notification';

import MaterialTable from '@material-table/core';
import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import View from '@material-ui/icons/FindInPage';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
// typings are here:
import { Icons } from '@material-table/core';
import theme from 'styles/simple/theme';
import { Grid, IconButton, TextField, Tooltip } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { formatDate } from 'utils/parseHelper';
import useGaTracker from 'GATracker';

const tableIcons: Icons = {
  Add: forwardRef((props, ref) => (
    <AddBox {...props} ref={ref} color="action" />
  )),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => (
    <DeleteOutline {...props} ref={ref} color="action" />
  )),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => (
    <View {...props} ref={ref} color="action" />
  )),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const useStyles = makeStyles(theme => ({
  preloader: {
    margin: '0 auto',
    color: '#007336',
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  sectionOutline: {
    border: '1px solid ' + theme.palette.primary.main,
    borderRadius: 4,
    marginTop: 10,
    marginBottom: 10,
    padding: '10px 10px 10px 10px',
  },
  iconButton: {
    marginTop: 16,
    padding: 10,
    background: theme.palette.primary.dark,
    '&:hover': {
      background: theme.palette.primary.light,
    },
  },
}));

const columns = [
  {
    title: 'Fecha',
    render: rowData => {
      return formatDate(new Date(rowData.createdAt));
    },
  },
  {
    title: 'Nombres',
    field: 'fullName',
    render: rowData => {
      return rowData.firstName + ' ' + rowData.lastName;
    },
  },
  { title: 'Destinatario', field: 'receiver' },
  { title: 'Celular', field: 'cellPhoneNumber' },
  /*{
    title: 'Módulo',
    field: 'module',
    render: rowData => {
      if (rowData.module === 'undefined') {
        return '';
      } else if (rowData.module === 'MEMBERSHIP') {
        return 'AFL';
      } else if (rowData.module === 'CREDIT') {
        return 'CRE';
      } else if (rowData.module === 'SECURITY') {
        return 'SEG';
      } else {
        return rowData.module;
      }
    },
  },*/
  { title: 'Asunto', field: 'subject' },
  {
    title: <EmailIcon />,
    field: 'emailSent',
    render: rowData => {
      if (rowData.emailSent === undefined) {
        return <PersonNotQueryIcon style={{ fill: '#cccccc' }} />;
      } else if (rowData.emailSent) {
        return (
          <Tooltip title={rowData.emailSentResponse}>
            <PersonNotReportedIcon style={{ fill: '#007700' }} />
          </Tooltip>
        );
      } else {
        return <PersonReportedIcon style={{ fill: '#ff0000' }} />;
      }
    },
  },
  {
    title: <SMSIcon />,
    field: 'smsSent',
    render: rowData => {
      if (rowData.smsSent === undefined) {
        return <PersonNotQueryIcon style={{ fill: '#cccccc' }} />;
      } else if (rowData.smsSent) {
        return (
          <Tooltip
            title={
              rowData.smsSentDate +
              ' :: ' +
              JSON.stringify(rowData.smsSentResponse)
            }
          >
            <PersonNotReportedIcon style={{ fill: '#007700' }} />
          </Tooltip>
        );
      } else {
        return <PersonReportedIcon style={{ fill: '#ff0000' }} />;
      }
    },
  },
  {
    title: <WhatsAppIcon />,
    field: 'waSent',
    render: rowData => {
      if (rowData.waSent === undefined) {
        return <PersonNotQueryIcon style={{ fill: '#cccccc' }} />;
      } else if (rowData.waSent) {
        return (
          <Tooltip title={rowData.waSentResponse}>
            <PersonNotReportedIcon style={{ fill: '#007700' }} />
          </Tooltip>
        );
      } else {
        return <PersonReportedIcon style={{ fill: '#ff0000' }} />;
      }
    },
  },
];

type FormValues = {
  text: string;
  fromDate: string;
  toDate: string;
};

export function NotificationAdminHomePage() {
  const [showPreloader, setShowPreloader] = useState(false);
  const [preloaded, setPreloaded] = useState(false);

  const [formData, setFormData] = useState({
    text: '',
    fromDate: '',
    toDate: '',
  });

  const [page, setPage] = useState(0);
  const [notificationTable, setNotificationTable] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [isFetching, setIsFetching] = useState(false);

  useGaTracker();

  const { home } = React.useContext(NotificationAdminContext);

  const [nowDate] = React.useState(moment(new Date()).format('DD-MM-YYYY'));

  const handleChange = evt => {
    const name = evt.target.name;
    const value =
      evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const getNotificationTable = useCallback(
    (query, p) => {
      new Promise((resolve, reject) => {
        setIsFetching(true);
        setShowPreloader(true);
        if (!p && p < 0) {
          p = page;
        }
        home({ page: p + 1, query: query }).then(resp => {
          setShowPreloader(false);
          setIsFetching(false);
          if (resp.respCode === 0) {
            setNotificationTable(resp.data.notifications);
            setTotalRowsCount(resp.data.rowsCount);
            setPageSize(resp.data.pageSize);
          } else {
            setNotificationTable([]);
            setTotalRowsCount(0);
            setPageSize(0);
          }
        });
      });
    },
    [home, page],
  );

  useEffect(() => {
    setShowPreloader(true);
    if (!preloaded) {
      getNotificationTable({}, 0);
      setPreloaded(true);
    }
  }, [
    setShowPreloader,
    home,
    page,
    getNotificationTable,
    preloaded,
    setPreloaded,
  ]);

  const { t } = useTranslation();

  const classes = useStyles();

  const { handleSubmit, control } = useForm<FormValues>({});

  const onSubmit = async data => {
    setShowPreloader(true);
    getNotificationTable(formData, 0);
  };

  return (
    <Container component="main" maxWidth="md">
      <Helmet>
        <title>{t(messages.i18nPageTitle())}</title>
        <meta name="description" content="{t(messages.i18nDescription())}" />
      </Helmet>

      <Container component="main" maxWidth="xl">
        <CssBaseline />
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Notificaciones
          </Typography>

          <section>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Controller
                    control={control}
                    name="text"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="search"
                        margin="normal"
                        fullWidth
                        id="text"
                        value={formData.text}
                        onChange={handleChange}
                        label="Busque sobre uno o varios campos"
                        autoComplete="false"
                        helperText="Documento, NIT, nombres, apellidos, empresa, correo electrónico, (*)"
                        autoFocus
                        InputLabelProps={{ shrink: true }}
                        variant="standard"
                        style={{ paddingRight: '0px' }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xl={1}>
                  <Controller
                    control={control}
                    name="fromDate"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="date"
                        margin="normal"
                        fullWidth
                        id="fromDate"
                        value={formData.fromDate}
                        onChange={handleChange}
                        label="Desde"
                        defaultValue={nowDate}
                        autoComplete="fromDate"
                        autoFocus
                        InputLabelProps={{ shrink: true }}
                        variant="standard"
                        style={{ paddingRight: '0px', width: '180px' }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xl={1}>
                  <Controller
                    control={control}
                    name="toDate"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="date"
                        margin="normal"
                        fullWidth
                        id="toDate"
                        value={formData.toDate}
                        onChange={handleChange}
                        label="Hasta"
                        autoComplete="toDate"
                        autoFocus
                        InputLabelProps={{ shrink: true }}
                        variant="standard"
                        style={{ paddingRight: '0px', width: '180px' }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xl={1}>
                  <Tooltip
                    placement="top"
                    title="Consultas en línea"
                    aria-label="Consultas en línea"
                  >
                    <IconButton
                      type="submit"
                      color="primary"
                      className={classes.iconButton}
                      aria-label="directions"
                    >
                      <SearchIcon style={{ fill: '#FFFFFF' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
              <p>
                (*) Para coincidencia de varias palabras, al igual que para
                correo electrónico se debe colocar el texto entre comillas, ej:
                "Adriana Quintero", "carlosp1709@simplecoop.co"
              </p>
            </form>
          </section>

          {showPreloader ? <PreLoader /> : null}

          <MaterialTable
            icons={tableIcons}
            columns={columns}
            isLoading={isFetching}
            page={page}
            totalCount={totalRowsCount}
            data={notificationTable}
            onPageChange={p => {
              setPage(p);
              getNotificationTable(formData, p);
            }}
            options={{
              pageSize,
              loadingType: 'linear',
              search: false,
              paging: true,
              sorting: false,
              filtering: false,
              showTitle: false,
              columnResizable: false,
              exportAllData: false,
              padding: 'dense',
              pageSizeOptions: [pageSize, 100, 200],
              paginationType: 'normal',
              actionsColumnIndex: -1,
              headerStyle: {
                backgroundColor: theme.palette.primary.light,
                color: '#FFF',
                whiteSpace: 'nowrap',
                textAlign: 'center',
              },
              rowStyle: {
                backgroundColor: '#eee',
                whiteSpace: 'nowrap',
              },
            }}
            localization={{
              pagination: {
                labelDisplayedRows: '{from}-{to} de {count}',
                labelRowsSelect: 'filas',
                labelRowsPerPage: 'Filas por página',
                firstAriaLabel: 'Primera Página',
                firstTooltip: 'Primera Página',
                previousAriaLabel: 'Página Anterior',
                previousTooltip: 'Página Anterior',
                nextAriaLabel: 'Página Siguiente',
                nextTooltip: 'Página Siguiente',
                lastAriaLabel: 'Última Página',
                lastTooltip: 'Última Página',
              },
              toolbar: {
                nRowsSelected: '{0} solicitud(es) seleccionado(as)',
                addRemoveColumns: 'Agregar o quitar columnas',
                showColumnsTitle: 'Mostrar Columnas',
                showColumnsAriaLabel: 'Mostrar Columnas',
                exportTitle: 'Exportar',
                exportAriaLabel: 'Exportar',
                searchTooltip: 'Buscar',
                searchPlaceholder: 'Busar',
              },
              header: {
                actions: 'Acciones',
              },
              body: {
                emptyDataSourceMessage: 'Sin notificaciones para mostrar',
                addTooltip: 'Agregar',
                deleteTooltip: ' Borrar',
                editTooltip: 'Editar',
                filterRow: {
                  filterTooltip: 'Filtro',
                  filterPlaceHolder: '',
                },
                editRow: {
                  deleteText: 'Confirma el borrado?',
                  cancelTooltip: 'Cancelar',
                  saveTooltip: 'Guardar',
                },
              },
              grouping: {
                placeholder: 'Arrastrar encabezado...',
                groupedBy: 'Agrupado por:',
              },
            }}
            actions={[]}
          />
        </div>
      </Container>
    </Container>
  );
}
